import {createEntity, EntityAdditional, entityInitial} from "../../../../store/models";
import {pmPortalStateFeatureSelector} from "../features";
import {ResponseWorkflowData} from "../../../admin/workflows/models/response-workflow-data";

export const workflowsFeatureKey = 'workflows';
export const workflowsEntity= createEntity<ResponseWorkflowData, EntityAdditional>(
    pmPortalStateFeatureSelector,
    workflowsFeatureKey,
    entityInitial({}),
);